import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Icon from '../../components/AppIcon';
import Header from '../../components/ui/Header';

const FAQ_ITEMS = [
  {
    question: 'How do I add a new site?',
    answer: 'Navigate to Sites from the main menu, then click "Add New Site". Fill in the site details and follow the setup wizard.'
  },
  {
    question: 'How do I invite team members?',
    answer: 'Go to Workers from the main menu and click "Invite Worker". Enter their email address and assign a role.'
  },
  {
    question: 'How do I upload documents?',
    answer: 'Open any site, go to the Documents tab, and click "Upload Document". Supported formats include PDF, Word, and Excel files.'
  },
  {
    question: 'How do I generate a compliance report?',
    answer: 'Navigate to Compliance Report from the main menu. Select the site and date range, then click "Generate Report".'
  },
  {
    question: 'How do I reset my password?',
    answer: 'On the login page, click "Forgot password?" and enter your email address. You will receive a reset link shortly.'
  }
];

const HelpSupport = () => {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <div className="pt-[72px]">
        <div className="max-w-3xl mx-auto px-4 py-8">
          <div className="flex items-center gap-3 mb-8">
            <button
              onClick={() => navigate(-1)}
              className="flex items-center justify-center w-9 h-9 rounded-md border border-border hover:bg-muted transition-colors"
            >
              <Icon name="ArrowLeft" size={18} />
            </button>
            <div>
              <h1 className="text-2xl font-bold text-foreground">Help &amp; Support</h1>
              <p className="text-sm text-muted-foreground">Find answers and get assistance</p>
            </div>
          </div>

          {/* Contact Cards */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            <div className="bg-card rounded-lg shadow-elevation-1 p-5 flex items-start gap-4">
              <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg flex-shrink-0">
                <Icon name="Mail" size={20} className="text-accent" />
              </div>
              <div>
                <p className="font-semibold text-foreground">Email Support</p>
                <p className="text-sm text-muted-foreground mt-1">support@site-proof.app</p>
                <p className="text-xs text-muted-foreground mt-1">Response within 24 hours</p>
              </div>
            </div>
            <div className="bg-card rounded-lg shadow-elevation-1 p-5 flex items-start gap-4">
              <div className="flex items-center justify-center w-10 h-10 bg-accent/10 rounded-lg flex-shrink-0">
                <Icon name="BookOpen" size={20} className="text-accent" />
              </div>
              <div>
                <p className="font-semibold text-foreground">Documentation</p>
                <p className="text-sm text-muted-foreground mt-1">Browse our knowledge base</p>
                <p className="text-xs text-muted-foreground mt-1">Guides and tutorials</p>
              </div>
            </div>
          </div>

          {/* FAQ */}
          <div className="bg-card rounded-lg shadow-elevation-1 p-6">
            <h2 className="text-lg font-semibold text-foreground mb-4 flex items-center gap-2">
              <Icon name="HelpCircle" size={20} className="text-accent" />
              Frequently Asked Questions
            </h2>
            <div className="space-y-2">
              {FAQ_ITEMS?.map((item, index) => (
                <div key={index} className="border border-border rounded-lg overflow-hidden">
                  <button
                    onClick={() => toggleFaq(index)}
                    className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-muted transition-colors cursor-pointer"
                  >
                    <span className="font-medium text-foreground text-sm">{item?.question}</span>
                    <Icon
                      name={openIndex === index ? 'ChevronUp' : 'ChevronDown'}
                      size={16}
                      className="text-muted-foreground flex-shrink-0 ml-2"
                    />
                  </button>
                  {openIndex === index && (
                    <div className="px-4 pb-4 pt-1">
                      <p className="text-sm text-muted-foreground">{item?.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HelpSupport;
